{
  "completed": "Completado: ",
  "current": "Actual: ",
  "notCompleted": "No se ha completado: ",
  "steplist": "Lista de pasos"
}
